import React from "react"
import { sanitize } from "isomorphic-dompurify"
import { marked } from "marked"
import parse from "html-react-parser"
import { MarkdownPropsType } from "./types"

export default function Markdown({
  children,
  className,
  tagAttrs,
  onClick,
}: MarkdownPropsType) {
  const renderer = new marked.Renderer()
  renderer.link = (href, title, text) => {
    let attrs = {
      href: href,
      title: title ?? "",
      target: "_blank",
    }
    if (tagAttrs?.a) {
      attrs = { ...attrs, ...tagAttrs?.a }
    }
    return `<a ${Object.entries(attrs)
      .map(([k, v]) => `${k}="${v}"`)
      .join(" ")}>${text}</a>`
  }
  marked.setOptions({ renderer })

  const createMarkup = () =>
    parse(
      sanitize(children ? (marked(children) as string) : "", {
        ADD_ATTR: ["target"],
      })
    )

  return (
    <>
      {className || onClick ? (
        <div className={className} onClick={onClick}>
          {createMarkup()}
        </div>
      ) : (
        <>{createMarkup()}</>
      )}
    </>
  )
}
